/* tslint:disable:no-shadowed-variable */
import { RootState } from '@/store/types'
import { keyBy } from 'lodash'
import { GetterTree } from 'vuex'
import { FormState } from './types'

export const getters: GetterTree<FormState, RootState> = {
  /**
   * Returns a dictionary of the loaded widgets keyed by their id.
   */
  widgetsById: state => {
    return keyBy(state.widgets, 'id')
  },
  getWidgetById: (_, getters) => (id: string) => getters.widgetsById[id],
  /**
   * Gets the active widgets for rendering by the Manager Widget.
   */
  activeWidget: (state, getters) => {
    return getters.widgetsById[state.activeWidgetId]
  },
  getMessages: state => state.messages,
  getQueryFields: state => state.queryFields,
  favicon: state => state.icons.favicon,
  locales: state => {
    const messages = state.messages || {}
    return Object.keys(messages)
  }
}
